import * as React from 'react';
import Animatable from './../Components/Animatable';
import { View, CenterButton, IconButton, rem } from './../libs/WebComponents';
import { Props } from './../types/types';
import { add_action, remove_action } from '../utils/FiltersAndActions';

const textStyle = {position:'relative',top:rem(-.5),color:'var(--bs-body-color)', fontSize:rem(1.2), fontWeight:400};
const BottomMenu = (props: Props)=>{

   const [loading, setLoading] = React.useState(false);
   const [tipError, setTipError] = React.useState(false);
   const is_finished = props.index === props.pages.length-1;
   const can_prev = props.index>0;


   React.useEffect(()=>{
      add_action('startLoadingTip',()=>{
         setTipError(false);
         setLoading(true);
   });
      add_action('stopLoadingTip',(args: {error: boolean})=>{
         setTipError(args.error);
         setLoading(false);
      });
      ()=>{
         remove_action('startLoadingTip');
         remove_action('stopLoadingTip');
      }
   },[]);

   return (
      <Animatable.View animation={'fadeIn'} className="bottom-menu-container">
         <View className="box" style={{paddingTop:rem(1.5),paddingLeft:rem(2),paddingRight:rem(2),alignItems:'center'}}>
               <CenterButton iconName={`${tipError?'Number-!':loading?'Loader':'Lightbulb'}`} containerClassName={loading?'spin':''} labelText="Toelichting" onPress={loading?null:props.showExplanationPage} size={rem(4)} iconSize={tipError?rem(2.5):rem(3.5)} textStyle={textStyle} iconColor={tipError?'var(--color-danger)':'var(--bs-body-color)'} color={'var(--color-orange-light)'} style={{opacity:props.showExplanationPage?1:.3}} />
               <CenterButton iconName="Revert" labelText="Start opnieuw" size={rem(4)} onPress={props.restart} textStyle={textStyle} iconColor={'var(--bs-body-color)'} color={'var(--color-orange-light)'} style={{marginLeft:rem(1)}} />
               <View style={{flex:4}} />
               <CenterButton iconName="ChevronLeft" labelText="Terug" iconSize={rem(3)} size={rem(4)} onPress={can_prev?props.prevPage:null} textStyle={textStyle} iconColor={'var(--bs-body-color)'} color={'var(--color-orange-light)'} style={{opacity:can_prev?1:.3}}/>
               <IconButton name={is_finished?'Check':'ChevronRight'} iconColor={'var(--color-white)'} color={is_finished?'var(--color-green)':'var(--color-purple-dark)'} iconSize={rem(5)} size={rem(8)} onPress={props.can_next?props.nextPage:null} containerStyle={{border:'2px solid '+(is_finished?'var(--bs-body-background-color)':'rgba(255,255,255,.2'),borderRadius:'100%',opacity:props.can_next?1:.3, position:'relative',marginLeft:rem(1),top:rem(-2)}}/>
         </View>
      </Animatable.View>
   );
}

export default React.memo(BottomMenu);